import { request } from "./api";

export function gethoteldata(params) {
  const { method, agent_id, agent_md, hid } = params;
  return request({
    url: "http://81.70.247.104/e/BookGateway_standalone.php",
    method: "GET",
    params: { method, agent_id, agent_md, hid },
  });
}

// export function gethotelroom(params) {
//   const { hid, tm1, tm2, ...restParams } = params;
//   const queryParams = new URLSearchParams({
//     ...restParams
//   }).toString();

//   return request({
//     url: `rooms/1/qnfkblyb/${hid}/${tm1}/${tm2}`,
//   });
// }
export function gethotelroom(params) {
  const { hid, tm1, tm2,...restParams } = params;
  const queryParams = new URLSearchParams({
    hid,
    tm1,
    tm2,
    ...restParams
  }).toString();
  return request({
    url: `e/json_yf.php?${queryParams}`,
  });
}
export function getroom(params) {
  const { hid, tm1, tm2,agent_id } = params;
  const queryParams = new URLSearchParams({
    hid,
    tm1,
    tm2,
    agent_id,
  }).toString();

  // 创建一个全局唯一的回调函数名
  const callbackName = `jsonp_${Date.now()}`;

  // 创建一个script标签
  const script = document.createElement('script');

  // 设置script标签的src属性，包含回调函数名和请求参数
  script.src = `http://81.70.247.104/e/json.php?${queryParams}&callback=${callbackName}`;

  // 将script标签添加到页面中
  document.body.appendChild(script);

  // 创建一个Promise，用于处理返回的值
  return new Promise((resolve, reject) => {
    // 创建全局回调函数
    window[callbackName] = function(response) {
      // 处理返回的数据


      // 移除script标签
      document.body.removeChild(script);

      // 清除全局回调函数
      delete window[callbackName];

      // 将返回的数据传递给Promise的resolve函数
      resolve(response);
    };
  });
}



export function gethotelpic(params) {
  const { method, agent_id, agent_md, hid } = params;
  return request({
    url: "http://81.70.247.104/e/BookGateway_standalone.php",
    method: "GET",
    params: { method, agent_id, agent_md, hid },
  });
}



// export function gethotelphone(params) {
//   const { fun, eid } = params;
//   const queryParams = new URLSearchParams({
//     fun,
//     eid,
//   }).toString();


//   // 创建一个全局唯一的回调函数名
//   const callbackName = `jsonp_${Date.now()}`;

//   // 创建一个script标签
//   const script = document.createElement('script');

//   // c属性，包含回调函数名和请求参数
//   script.src = `https://tg2.tetuijiudian.com/apivhotel2/agentgettel?${queryParams}&callback=${callbackName}`;

//   // 将script标签添加到页面中
//   document.body.appendChild(script);

//   // 创建一个Promise，用于处理返回的值
//   return new Promise((resolve, reject) => {
//     // 创建全局回调函数
//     window[callbackName] = function(response) {
//       // 处理返回的数据


//       // 移除script标签
//       document.body.removeChild(script);

//       // 清除全局回调函数
//       delete window[callbackName];

//       // 将返回的数据传递给Promise的resolve函数
//       resolve(response);
//     };
//   });



// }




export async function gethotelphone(params) {
  const { fun, eid } = params;

  const url = 'http://81.70.247.104/e/json.php';

  const data = {
    fun,
    eid,
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    const result = await response.json();
    return result;

  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    throw error; // Propagate the error
  }
}
